module.exports = __webpack_public_path__ + "img/天麻.0ed5f595.jpg";